import { render, staticRenderFns } from "./oea-menu.vue?vue&type=template&id=f0da982c&scoped=true"
import script from "./oea-menu.vue?vue&type=script&lang=js"
export * from "./oea-menu.vue?vue&type=script&lang=js"
import style0 from "./oea-menu.vue?vue&type=style&index=0&id=f0da982c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0da982c",
  null
  
)

export default component.exports